import React from 'react';
import ModalContainer from './ModalContainer';

function InfoModal({ isVisible, setIsVisible, title, infoText }) {

    const infoTextContainer = {
        alignItems: 'left',
        padding: '0rem 1rem 1rem 1rem',
    }

    return (
        <ModalContainer isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={title}
            style={{ width: '280px' }}>
            <div style={infoTextContainer}>
                {infoText}
            </div>
        </ModalContainer>
    )
}

export default InfoModal;